

























import { Component, Mixins } from 'vue-property-decorator';
import TenantNotificationItem from '@/components/Globals/Overlay/Components/Items/TenantNotificationItem.vue';
import GlobalOverlayMethods from '@/mixins/GlobalOverlayMethods.vue';
import { SortingOption } from '@/ts/interfaces/Tickets';
import { Mutations } from '@/ts/store/Constants';

@Component({
    name: 'FilterStaffTicketsList',
    components: {
        TenantNotificationItem,
    },
})
export default class FilterStaffTicketsList extends Mixins(
    GlobalOverlayMethods,
) {
    public sortOptions: SortingOption[] = [
        { title: this.$t('tickets.newest-default', 'Newest - default'), action: 'NEWEST'  },
        { title: this.$t('tickets.oldest', 'Oldest'), action: 'OLDEST'  },
        { title: this.$t('tickets.project-(A-Z)', 'Project (A-Z)'), action: 'PROJECT' },
        { title: this.$t('tickets.priority-critical-low', 'Priority - Critical-Low'), action: 'PRIORITY_CRITICAL' },
        { title: this.$t('tickets.priority-low-critical', 'Priority - Low-Critical'), action: 'PRIORITY_LOW' },

    ];

    public defaultStatusOptions: SortingOption[] = [
        { title: this.$t('tickets.status-pending-first', 'Status - Pending first'), action: 'STATUS_PENDING' },
        { title: this.$t('tickets.status-in-progress-first', 'Status - In-progress first'), action: 'STATUS_INPROGRESS' },
    ];

    public completedStatusOptions: SortingOption[] = [
        { title: this.$t('tickets.status-completed-first', 'Status - Completed first'), action: 'STATUS_PENDING' },
        { title: this.$t('tickets.status-cancelled-first', 'Status - Cancelled first'), action: 'STATUS_INPROGRESS' },
    ];

    constructor() {
        super();
    }

    get allSortingOptions(): SortingOption[] {
        const statusOptions = this.activeTicketsType === 'completed'
            ? this.completedStatusOptions
            : this.defaultStatusOptions;

        return [...this.sortOptions, ...statusOptions];
    }

    get activeSortOption(): string {
        return this.$store.getters['UserTickets/getActiveStaffTicketsOrder'];
    }

    get activeTicketsType(): string {
        return this.$store.getters['UserTickets/getActiveStaffTicketsType'];
    }

    public selectSortOption(option: SortingOption) {
        if (option.action === this.activeSortOption) {
            return false;
        }

        this.$store.commit(Mutations.SET_ACTIVE_STAFF_TICKETS_ORDER, option.action);
        this.closeGlobalOverlay();
    }
}
